import React, {Fragment} from "react";
import {
    Route, Routes,
} from "react-router-dom";
import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import Home from "./Pages/Home/Home";
import Profile from "./Pages/Profile";
import Sellers from "./Pages/Seller/Sellers";
import Transactions from "./Pages/Transactions/Transactions";
import Products from "./Pages/Products/Products";
import Buyers from "./Pages/Buyers/Buyers";
import SellerDetails from "./Pages/Seller/SellerDetails";
import ProductDetails from "./Pages/Products/ProductDetails";
import BuyerDetails from "./Pages/Buyers/BuyerDetails";
import AppContent from "./Pages/AppContent/AppContent";
import Promotions from "./Pages/Promotions/Promotions";
import Settings   from "./Pages/Settings/Settings";
import Analytics  from "./Pages/Analytics/Analytics";
import Logs       from "./Pages/Logs/Logs";
import Disputes   from "./Pages/Disputes/Disputes";
import Support    from "./Pages/Support/Support";
import Appeals    from "./Pages/Appeals/Appeals";
import ReferralCodes from "./Pages/Referrals/ReferralCodes";
import DiscountCodes from "./Pages/Discounts/DiscountCodes";
import PreorderExtensions from "./Pages/PreorderExtensions/PreorderExtensions";

const Navigation = () => {

    return (
        <Fragment>
            <Routes>
                <Route path="/" element={<Login/>} />
                <Route path="/forgot" element={<ForgotPassword/>} />
                <Route path="/home" element={<Home/>} />
                <Route path="/profile" element={<Profile/>} />
                <Route path="/shops" element={<Sellers/>} />
                <Route path="/shops/:id" element={<SellerDetails/>} />
                <Route path="/transactions" element={<Transactions/>} />
                <Route path="/support" element={<Support/>} />
                <Route path="/disputes" element={<Disputes/>} />
                <Route path="/appeals" element={<Appeals/>} />
                <Route path="/referral-codes" element={<ReferralCodes/>} />
                <Route path="/discount-codes" element={<DiscountCodes/>} />
                <Route path="/preorder-extensions" element={<PreorderExtensions/>} />
                <Route path="/products" element={<Products/>} />
                <Route path="/products/:id" element={<ProductDetails/>} />
                <Route path="/buyers" element={<Buyers/>} />
                <Route path="/buyers/:id" element={<BuyerDetails/>} />
                <Route path="/catalog" element={<AppContent/>} />
                <Route path="/promotions" element={<Promotions/>} />
                <Route path="/settings"   element={<Settings/>}/>
                <Route path="/analytics" element={<Analytics/>}/>
                <Route path="/logs"      element={<Logs/>}/>
            </Routes>

        </Fragment>
    );

}

export default Navigation;
